import ContentPrice from '../contentprice/ContentPrice';
import Badge from '@core/components/badge/Badge';
import LinkButton from '@core/components/linkbutton/LinkButton';
import ActionButton from '@core/components/actionbutton/ActionButton';
import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';

import { useMutation } from 'react-query';
import { JobQualificationWaitingList, CourseWaitingList } from 'services/core';

import { Star1, ArrowRight2 } from 'iconsax-react';
import PremiumBadge from 'assets/icons/premium-badge-2.svg';

import classes from './ExploreContentCardNew.module.scss';
import StarRate from '@core/components/starrate/StarRate';
import { Box, LinearProgress } from '@mui/material';


const ContentTypeBadge = ({ type }) => {
	return (
		<div
			className={classes['content-badge-wrapper']}
			style={{ backgroundColor: type === 'course' ? '#4ECDC4' : '#BB3A90' }}>
			{type === 'course' ? 'Job Qualification' : 'Course'}
		</div>
	);
};

const ExploreContentCardNew = ({ content, toast, isFeatured = false }) => {
	const isNotComingSoon = content.status !== 'coming_soon';

	return (
		<LinkButton
			kind="simple"
			target="_blank" rel="noopener noreferrer"
			to={`/${content.type === 'lecture' ? 'courses' : 'job-qualifications'}/${content.id}/${content.slug
				}`}>
			<div className={`${classes['content-card-detail']}`}>
				<img src={content.image} alt={content.title} />
				<div className={classes['card-badge-container']}>
					{!isFeatured && (
						<>
							{content.is_coming_soon && (
								<div className={classes['comingsoon-badge']}>
									Coming Soon
								</div>
							)}
							{content.is_new ? (
								<div className={classes['new-badge']}>
									New
								</div>
							) : <div></div>}
						</>
					)}
					{content?.is_free ?
						(
							<span className={classes['free-badge']}>Free</span>
						) : (
							<PremiumBadge />
						)
					}
				</div>
				<div className={`${classes['content-card-detail-title']}`}>
					<div className='d-flex flex-column gap-1 w-100'>
						<h5>{content.title}</h5>
					</div>
					<p className={`${classes['content-card-detail-description']}`}>
						{content.short_introduction}
					</p>

					<div
						className={`${classes['content-card-detail-footer']} d-flex flex-row justify-content-between align-items-center`}>
						{isNotComingSoon && (
							<>
								{(content.progress_percentage && content.status === 'progressing') ? (
									<Box className='w-75'>
										<span className={classes['percentage']}>{content.progress_percentage}% Completed</span>
										<LinearProgress
											variant="determinate"
											value={content.progress_percentage}
											sx={{
												borderRadius: '5px', // Adjust border radius
											}}
										/>
									</Box>
								) : (
									<>
										{!!content.rate_average ? (
											<StarRate rate_average={content.rate_average} />
										): (<div></div>)}
										<div>
											<ProficiencyBadge proficiency={content?.proficiency} />
										</div>
									</>
								)}

							</>
						)}

					</div>
				</div>
			</div>
		</LinkButton>
	);
};

export default ExploreContentCardNew;
